import React, { Component } from 'react';

import Sprite from './Sprite';

class PKMNEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      compareMoves: [],
    }
  }

  render() {
    return (
      <section className="entry">
        <div>
          <Sprite name={this.props.searchName} />
          {this.props.name}
          <div className="group">
            {this.props.eggGroup1}
            {this.props.eggGroup2
              ? ` | ${this.props.eggGroup2}`
              : null}
          </div>
        </div>
        <div className="move-list flex space-between">
          <div>
            <h4>Learned Moves</h4>
            {this.displayLearnedMoves(this.props.learnedMoves)}
          </div>
          <div className="move-select">
            Select up to four egg moves.
              <form>
              {this.props.eggMoves ? this.displayCheckboxes() : "No egg moves to choose."}
            </form>
          </div>
        </div>
        <div>
          <div>
            {this.displayEggChains()}
          </div>
          <h4>Egg Moves</h4>
          {this.props.eggMoves
            ? this.displayEggMoves(this.props.eggMoves)
            : 'See lower evolution for egg moves.'}
        </div>
      </section>
    );
  }

  displayLearnedMoves(moveList) {
    const { learnedMoves } = this.props;
    let moves = [];
    for (let level in moveList) {
      if (Array.isArray(learnedMoves[level])) {
        learnedMoves[level].forEach(move => {
          moves.push(
            <div key={`${level}-${move}`}>
              {`[${level}]: `}
              {move}
            </div>
          );
        })
      } else {
        moves.push(
          <div key={`${level}-${learnedMoves[level]}`}>
            {`[${level}]: `}
            {learnedMoves[level]}
          </div>
        )
      }
    }
    return moves;
  }

  displayCheckboxes() {
    let inputs = [];
    this.props.eggMoves.forEach(move => {
      inputs.push(<div key={`input-${move}`}>
        <input
          type="checkbox"
          id={move}
          name={move}
          onChange={(e) => this.populateMoves(e)}
        />
        {move}
      </div>);
    });
    return inputs;
  }

  displayEggMoves(moveList) {
    let moves = [];
    moveList.forEach(move => {
      let pkmnWithChain = this.props.searchEggMoves(move, this.props.searchName);
      let sprites = pkmnWithChain.map(pokemon => {
        return (
          <button
            className={`${this.props.isEggChain(move, pokemon.name) ? 'chain' : 'normal'}`}
            onClick={() => this.props.searchByPokemon(pokemon.name)}
            key={`icon-${pokemon.name}-${move}`}
          >
            <Sprite
              name={pokemon.name}
            />
          </button>
        )
      })
      moves.push(
        <div
          className="flex egg-moves"
          key={`${this.props.name}-${move}`}
        >
          <div className="move-name">
            {move}:
          </div>
          <div className="wrap sprite-list">
            {sprites}
          </div>
        </div>
      )
    });
    return moves;
  }

  displayEggChains() {
    const { compareMoves } = this.state;
    const { searchName, searchEggMoves, createMultiEggChain } = this.props;
    let listedPokemon = [];
    switch (compareMoves.length) {
      case 1: listedPokemon = searchEggMoves(compareMoves[0], searchName); break;
      case 2:
      case 3:
      case 4: listedPokemon = createMultiEggChain(compareMoves, searchName); break;
      default: break;
    }
    let spriteDisplay = [];
    listedPokemon.forEach(pokemon => {
      spriteDisplay.push(
        <Sprite
          name={pokemon.name}
        />
      );
    });
    return spriteDisplay;
  }

  populateMoves = (e) => {
    let clone = this.state.compareMoves;
    if (e.target.checked) {
      clone.push(e.target.name)
      this.setState({ compareMoves: clone });
    } else {
      if (clone.includes(e.target.name)) {
        let compareMoves = clone.filter(move => {
          return move !== e.target.name;
        });
        this.setState({ compareMoves });
      } else {
        console.log("The move wasn't in the array in the first place?");
      }
    }
    this.displayEggChains();
  }
}

export default PKMNEntry;